import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import pageHero from './pageHero';

/**
 * flarum/subscriptions' /following route is the index page with a filter, so
 * it showed the welcome hero ("Welcome to BimmerDock Community"), or
 * fof/follow-tags' own centred one. It gets a page hero instead; with
 * fof/follow-tags the subtitle mentions followed tags too.
 */
export default function followingHero() {
  override(IndexPage.prototype, 'hero', function (original) {
    if (app.current.get('routeName') !== 'following') return original();
    const subtitle = 'fof-follow-tags' in flarum.extensions ? 'subtitle_with_tags' : 'subtitle';
    return pageHero(app.translator.trans('flarum-subscriptions.forum.index.following_link'), app.translator.trans(`bimmerdock-theme.forum.following.${subtitle}`));
  });
}